//@ts-ignore
import BpmnModeler from "bpmn-js/lib/Modeler";
import {
  ProcessModelDataTypes,
} from "hooks/useBpmnModeler/useBpmnJsModeler";
import ElementProperties from "./PropertyPanelEditor";
import { useTranslations } from "hooks";
import { Box, Typography } from "@mui/material";
import { getTranslation } from "common";
import { ExtensionElements, ExtensionElementType } from "model/processModel";
import { Data } from "components/dialogs/ProcessModelSchema";

interface PropertiesViewTypes {
  modeler: BpmnModeler;
  selectedElements: any;
  currentElement: any;
  processModelData: ProcessModelDataTypes;
  getRequestBodyForExtensionElements: () => Array<ExtensionElementType>;
  setProcessModelData: (data: ProcessModelDataTypes) => void;
  // getSelectedLanguage: () => string;
  openDiagram: (xml: string, shouldShowInTheViewPort: boolean, onSuccess?: () => void) => Promise<void>;
  primaryPropertiesNameRef: any;
  onTriggerAutosave?: () => void;
  schema: Data[];
  extensionElements?: ExtensionElements;
  idToUse:string | number | undefined;
  robotDialogOpen?: (isOpen: boolean) => void;
  robotValidationRef?: React.MutableRefObject<(() => boolean) | null>;
}

const PropertiesView = (props: PropertiesViewTypes) => {
  const {
    modeler,
    selectedElements,
    currentElement,
    processModelData,
    getRequestBodyForExtensionElements,
    setProcessModelData,
    // getSelectedLanguage,
    openDiagram,
    primaryPropertiesNameRef,
    onTriggerAutosave,
    schema,
    extensionElements,
    idToUse,
    robotDialogOpen,
    robotValidationRef,
  } = props;
  const translations = useTranslations();
  return (
    <Box height={"100%"} sx={{ overflowY: "auto" }}>
      {selectedElements.length === 1 && currentElement && (
        <ElementProperties
          modeler={modeler}
          element={currentElement}
          processModelData={processModelData}
          getRequestBodyForExtensionElements={
            getRequestBodyForExtensionElements
          }
          setProcessModelData={setProcessModelData}
          // getSelectedLanguage={getSelectedLanguage}
          openDiagram={openDiagram}
          primaryPropertiesNameRef={primaryPropertiesNameRef}
          onTriggerAutosave={onTriggerAutosave}
          schema={schema}
          extensionElements={extensionElements}
          idToUse={idToUse}
          robotDialogOpen={robotDialogOpen}
          robotValidationRef={robotValidationRef}
        />
      )}
      {selectedElements.length === 0 && (
        <Typography>
          {getTranslation(translations, "pm.propertyeditor.label.select_element")}
        </Typography>
      )}
      {selectedElements.length > 1 && (
        <Typography>
          {getTranslation(translations, "pm.propertyeditor.label.select_single_element")}
        </Typography>
      )}
    </Box>
  );
};

export default PropertiesView;
